export const jsonParser = (string, key = '') => {
  let parsedJson = {};
  try {
    parsedJson = JSON.parse(string);
  } catch (error) {
    console.tron.log('JSON ERROR', `${error}`, key);
  }
  return parsedJson;
};
